export type RequestStatus = "idle" | "loading" | "succeeded" | "failed";

/**
 * Server data a screen waits for, stored once. `requestId` belongs to the request whose answer is
 * awaited: an answer to an older request (the user has moved on to another record) is ignored.
 */
export interface Resource<T> {
    data: T | null;
    status: RequestStatus;
    requestId?: string;
}

export const emptyResource = <T>(): Resource<T> => ({ data: null, status: "idle" });

// Reducer helpers for a thunk's pending / fulfilled / rejected cases. They mutate the Immer draft.
// The data is kept while a new request loads, so a refresh after a save does not blank the screen.

export function startLoading<T>(resource: Resource<T>, requestId: string): void {
    resource.status = "loading";
    resource.requestId = requestId;
}

export function finishLoading<T>(resource: Resource<T>, requestId: string, data: T): void {
    if (resource.requestId !== requestId) return;
    resource.data = data;
    resource.status = "succeeded";
    resource.requestId = undefined;
}

export function failLoading<T>(resource: Resource<T>, requestId: string): void {
    if (resource.requestId !== requestId) return;
    resource.status = "failed";
    resource.requestId = undefined;
}
